import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { AppProvider } from 'foundations-components/components/AppProvider';
import WindowDimensionsProvider from 'marketplace-ui-common/components/providers/WindowDimensionsProvider';
import HSAnalyticsProvider from 'marketplace-ui-common/tracking/components/HSAnalyticsProvider';
import { UsageTrackerProvider } from 'marketplace-ui-tracking';
import { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { Routes } from '../components/Routes';
import { AppContextProvider } from '../context/AppContext';
import { AuthProvider } from '../context/AuthContext';
import { jsx as _jsx } from "react/jsx-runtime";
const dataFetchingClient = new DataFetchingClient();
export function BaseApp({
  appContext,
  auth = {},
  history,
  usageTracker
}) {
  useEffect(() => {
    setDocumentTitle('marketplaceStorefront.htmlTitle');
  }, []);
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dataFetchingClient,
    children: /*#__PURE__*/_jsx(HSAnalyticsProvider, {
      children: /*#__PURE__*/_jsx(WindowDimensionsProvider, {
        children: /*#__PURE__*/_jsx(AppContextProvider, {
          value: appContext,
          children: /*#__PURE__*/_jsx(AuthProvider, {
            value: auth,
            children: /*#__PURE__*/_jsx(UsageTrackerProvider, {
              tracker: usageTracker,
              children: /*#__PURE__*/_jsx(AppProvider, {
                children: /*#__PURE__*/_jsx(Router, {
                  history: history,
                  children: /*#__PURE__*/_jsx(Routes, {})
                })
              })
            })
          })
        })
      })
    })
  });
}